export const LN: { [key: string]: string } = {
  '10000000000000000': '-4605170185988091324',
  '20000000000000000': '-3912023005428146036',
  '30000000000000000': '-3506557897319981655',
  '40000000000000000': '-3218875824868200726',
  '50000000000000000': '-2995732273553990971',
  '60000000000000000': '-2813410716760036345',
  '70000000000000000': '-2659260036932778042',
  '80000000000000000': '-2525728644308255418',
  '90000000000000000': '-2407945608651871963',
  '100000000000000000': '-2302585092994045662',
  '110000000000000000': '-2207274913189720782',
  '120000000000000000': '-2120263536200091034',
  '130000000000000000': '-2040220828526554613',
  '140000000000000000': '-1966112856372832752',
  '150000000000000000': '-1897119984885881303',
  '160000000000000000': '-1832581463748310131',
  '170000000000000000': '-1771956841931875289',
  '180000000000000000': '-1714798428091926678',
  '190000000000000000': '-1660731206821650907',
  '200000000000000000': '-1609437912434100374',
  '210000000000000000': '-1560647748264668367',
  '220000000000000000': '-1514127732629775513',
  '230000000000000000': '-1469675970058941676',
  '240000000000000000': '-1427116355640145749',
  '250000000000000000': '-1386294361119890618',
  '260000000000000000': '-1347073647966609323',
  '270000000000000000': '-1309333319983762296',
  '280000000000000000': '-1272965675812887443',
  '290000000000000000': '-1237874356001617340',
  '300000000000000000': '-1203972804325935993',
  '310000000000000000': '-1171182981502945122',
  '320000000000000000': '-1139434283188364823',
  '330000000000000000': '-1108662624521611134',
  '340000000000000000': '-1078809661371929978',
  '350000000000000000': '-1049822124498677687',
  '360000000000000000': '-1021651247531981366',
  '370000000000000000': '-994252273343866924',
  '380000000000000000': '-967584026261705599',
  '390000000000000000': '-941608539858444942',
  '400000000000000000': '-916290731874155064',
  '410000000000000000': '-891598119283783565',
  '420000000000000000': '-867500567704723063',
  '430000000000000000': '-843970070294528944',
  '440000000000000000': '-820980552069830205',
  '450000000000000000': '-798507696217771611',
  '460000000000000000': '-776528789498996368',
  '470000000000000000': '-755022584278032781',
  '480000000000000000': '-733969175080200438',
  '490000000000000000': '-713349887877464757',
  '500000000000000000': '-693147180559945309',
  '510000000000000000': '-673344553263765597',
  '520000000000000000': '-653926467406664012',
  '530000000000000000': '-634878272435969534',
  '540000000000000000': '-616186139423816984',
  '550000000000000000': '-597837000755620448',
  '560000000000000000': '-579818495252942134',
  '570000000000000000': '-562118918153541218',
  '580000000000000000': '-544727175441672031',
  '590000000000000000': '-527632742082371917',
  '600000000000000000': '-510825623765990683',
  '610000000000000000': '-494296321814780119',
  '620000000000000000': '-478035800942999812',
  '630000000000000000': '-462035459596558681',
  '640000000000000000': '-446287102628419513',
  '650000000000000000': '-430782916092454257',
  '660000000000000000': '-415515443961665823',
  '670000000000000000': '-400477566597125309',
  '680000000000000000': '-385662480811984669',
  '690000000000000000': '-371063681390831985',
  '700000000000000000': '-356674943938732380',
  '710000000000000000': '-342490308946775946',
  '720000000000000000': '-328504066972036058',
  '730000000000000000': '-314710744839700239',
  '740000000000000000': '-301105092783921614',
  '750000000000000000': '-287682072451780927',
  '760000000000000000': '-274436845701760290',
  '770000000000000000': '-261364764134407519',
  '780000000000000000': '-248461359298499631',
  '790000000000000000': '-235722333521069874',
  '800000000000000000': '-223143551314209756',
  '810000000000000000': '-210721031315652603',
  '820000000000000000': '-198450938723838255',
  '830000000000000000': '-186329578191493444',
  '840000000000000000': '-174353387144777753',
  '850000000000000000': '-162518929497774913',
  '860000000000000000': '-150822889734583635',
  '870000000000000000': '-139262067333507650',
  '880000000000000000': '-127833371509884896',
  '890000000000000000': '-116533816255951530',
  '900000000000000000': '-105360515657826301',
  '910000000000000000': '-94310679471241327',
  '920000000000000000': '-83381608939051058',
  '930000000000000000': '-72570692834835431',
  '940000000000000000': '-61875403718087472',
  '950000000000000000': '-51293294387550533',
  '960000000000000000': '-40821994520255129',
  '970000000000000000': '-30459207484708546',
  '980000000000000000': '-20202707317519448',
  '990000000000000000': '-10050335853501441',
  '1000000000000000000': '0',
  '1010000000000000000': '9950330853168083',
  '1020000000000000000': '19802627296179713',
  '1030000000000000000': '29558802241544403',
  '1040000000000000000': '39220713153281296',
  '1050000000000000000': '48790164169432003',
  '1060000000000000000': '58268908123975776',
  '1070000000000000000': '67658648473814805',
  '1080000000000000000': '76961041136128325',
  '1090000000000000000': '86177696241052332',
  '1100000000000000000': '95310179804324860',
  '1110000000000000000': '104360015324242768',
  '1120000000000000000': '113328685307003175',
  '1130000000000000000': '122217632724249201',
  '1140000000000000000': '131028262406404093',
  '1150000000000000000': '139761942375158697',
  '1160000000000000000': '148420005118273278',
  '1170000000000000000': '157003748809664751',
  '1180000000000000000': '165514438477573392',
  '1190000000000000000': '173953307123438017',
  '1200000000000000000': '182321556793954626',
  '1210000000000000000': '190620359608649720',
  '1220000000000000000': '198850858745165190',
  '1230000000000000000': '207014169384326127',
  '1240000000000000000': '215111379616945497',
  '1250000000000000000': '223143551314209756',
  '1260000000000000000': '231111720963386628',
  '1270000000000000000': '239016900470499906',
  '1280000000000000000': '246860077931525798',
  '1290000000000000000': '254642218373580746',
  '1300000000000000000': '262364264467491052',
  '1310000000000000000': '270027137213060176',
  '1320000000000000000': '277631736598279487',
  '1330000000000000000': '285178942233662397',
  '1340000000000000000': '292669613962820001',
  '1350000000000000000': '300104592450338080',
  '1360000000000000000': '307484699747960640',
  '1370000000000000000': '314810739840033548',
  '1380000000000000000': '322083499169113323',
  '1390000000000000000': '329303747142600390',
  '1400000000000000000': '336472236621212931',
  '1410000000000000000': '343589704390076910',
  '1420000000000000000': '350656871613169363',
  '1430000000000000000': '357674444271815912',
  '1440000000000000000': '364643113587909252',
  '1450000000000000000': '371563556432483034',
  '1460000000000000000': '378436435720245070',
  '1470000000000000000': '385262400790644933',
  '1480000000000000000': '392042087776023696',
  '1490000000000000000': '398776119957367773',
  '1500000000000000000': '405465108108164382',
  '1510000000000000000': '412109650826832960',
  '1520000000000000000': '418710334858185020',
  '1530000000000000000': '425267735404344094',
  '1540000000000000000': '431782416425537791',
  '1550000000000000000': '438254930931155253',
  '1560000000000000000': '444685821261445678',
  '1570000000000000000': '451075619360216689',
  '1580000000000000000': '457424847038875436',
  '1590000000000000000': '463734016232140157',
  '1600000000000000000': '470003629245735553',
  '1610000000000000000': '476234178996371629',
  '1620000000000000000': '482426149244292708',
  '1630000000000000000': '488580014818670966',
  '1640000000000000000': '494696241836107054',
  '1650000000000000000': '500775287912489241',
  '1660000000000000000': '506817602368451864',
  '1670000000000000000': '512823626428663739',
  '1680000000000000000': '518793793415167558',
  '1690000000000000000': '524728528934982105',
  '1700000000000000000': '530628251062170396',
  '1710000000000000000': '536493370514568475',
  '1720000000000000000': '542324290825361673',
  '1730000000000000000': '548121408509687578',
  '1740000000000000000': '553885113226437660',
  '1750000000000000000': '559615787935422686',
  '1760000000000000000': '565313809050060413',
  '1770000000000000000': '570979546585737773',
  '1780000000000000000': '576613364303993780',
  '1790000000000000000': '582215619852663628',
  '1800000000000000000': '587786664902119007',
  '1810000000000000000': '593326845277734378',
  '1820000000000000000': '598836501088703982',
  '1830000000000000000': '604315966853329572',
  '1840000000000000000': '609765571620894252',
  '1850000000000000000': '615185639090233450',
  '1860000000000000000': '620576487725109878',
  '1870000000000000000': '625938430866495256',
  '1880000000000000000': '631271776841857839',
  '1890000000000000000': '636576829071551011',
  '1900000000000000000': '641853886172394777',
  '1910000000000000000': '647103242058538504',
  '1920000000000000000': '652325186039690181',
  '1930000000000000000': '657520002916794184',
  '1940000000000000000': '662687973075236763',
  '1950000000000000000': '667829372575655435',
  '1960000000000000000': '672944473242425860',
  '1970000000000000000': '678033542749897138',
  '1980000000000000000': '683096844706443869',
  '1990000000000000000': '688134638736401027',
  '2000000000000000000': '693147180559945309'
};
